namespace Gamification.Gamification {
    export interface ProdottiEsperienzeClassiRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoEsperienzaClasse?: number;
        IdProdottoEsperienza?: number;
        IdProdottoClasse?: number;
        IdProdottoEsperienzaIdProdotto?: number;
        IdProdottoEsperienzaIdentifierEsperienza?: string;
        IdProdottoEsperienzaNome?: string;
        IdProdottoEsperienzaDescrizione?: string;
        IdProdottoClasseIdProdotto?: number;
        IdProdottoClasseIdentifierClasse?: string;
        IdProdottoClasseNome?: string;
        IdProdottoClasseDescrizione?: string;
    }

    export namespace ProdottiEsperienzeClassiRow {
        export const idProperty = 'IdProdottoEsperienzaClasse';
        export const localTextPrefix = 'Gamification.ProdottiEsperienzeClassi';
        export const lookupKey = 'Gamification.ProdottiEsperienzeClassi';

        export function getLookup(): Q.Lookup<ProdottiEsperienzeClassiRow> {
            return Q.getLookup<ProdottiEsperienzeClassiRow>('Gamification.ProdottiEsperienzeClassi');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoEsperienzaClasse = "IdProdottoEsperienzaClasse",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            IdProdottoClasse = "IdProdottoClasse",
            IdProdottoEsperienzaIdProdotto = "IdProdottoEsperienzaIdProdotto",
            IdProdottoEsperienzaIdentifierEsperienza = "IdProdottoEsperienzaIdentifierEsperienza",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome",
            IdProdottoEsperienzaDescrizione = "IdProdottoEsperienzaDescrizione",
            IdProdottoClasseIdProdotto = "IdProdottoClasseIdProdotto",
            IdProdottoClasseIdentifierClasse = "IdProdottoClasseIdentifierClasse",
            IdProdottoClasseNome = "IdProdottoClasseNome",
            IdProdottoClasseDescrizione = "IdProdottoClasseDescrizione"
        }
    }
}
